import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import ContactSupport from '../components/ContactSupport';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF5F8] to-white">
      <Navbar />

      {/* Content */}
      <div className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-4xl">
          {/* Hero */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
            <p className="text-xl text-gray-600">
              Last updated: April 2026
            </p>
          </div>

          {/* Content */}
          <Card className="p-8 md:p-12 border-pink-100 shadow-lg">
            <div className="prose prose-lg max-w-none text-gray-700">
              <p className="mb-8">
                This Privacy Policy describes how Ovalu, a product of LabVIEWDevops, collects, uses, and protects user data.
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Information We Collect</h2>
                <p className="mb-4">We may collect personal and usage data including:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Name and email address (if provided)</li>
                  <li>Menstrual cycle data (dates, symptoms, notes)</li>
                  <li>App usage data for improving user experience</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. How We Use Your Information</h2>
                <p className="mb-4">We use the collected data to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide cycle tracking and predictions</li>
                  <li>Improve app functionality and performance</li>
                  <li>Send important updates (if opted-in)</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Data Protection</h2>
                <p>
                  We implement appropriate security measures to protect your data. 
                  We do not sell, trade, or share your personal information with third parties.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Data Storage</h2>
                <p>Your data is stored securely and used only for providing app services.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Third-Party Services</h2>
                <p>
                  We may use trusted third-party services like Razorpay for payment processing. 
                  These services have their own privacy policies.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. User Rights</h2>
                <p>Users can request deletion of their data by contacting us.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Contact</h2>
                <p className="mb-2">For any privacy-related queries:</p>
                <p className="font-semibold text-[#FF6B9D]">
                  Email: support@ovalu.app
                </p>
              </section>
            </div>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Privacy;
